import { render, staticRenderFns } from "./OperativeTable.vue?vue&type=template&id=3b82e5d4&"
import script from "./OperativeTable.vue?vue&type=script&lang=js&"
export * from "./OperativeTable.vue?vue&type=script&lang=js&"
import style0 from "./OperativeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports